var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m11.309 7.871-4.594 4.813a.64.64 0 0 1-.465.191.66.66 0 0 1-.492-.191L1.164 7.87c-.246-.273-.246-.684.027-.93a.653.653 0 0 1 .93.028l3.473 3.636V1.31c0-.383.273-.657.629-.657.328 0 .683.274.683.657v9.296l3.446-3.636a.65.65 0 0 1 .93-.028c.273.247.273.657.027.93"
  })));
};
export default SvgArrowDown;